import TransactionTable from "../_misc/TransactionTable";
import { useState } from "react";

const Transactions = () => {
  const [filters, setFilters] = useState<{ [key: string]: string }>({
    responseCode: "",
    cardtype: "",
    paymentType: "",
    rrn: "",
    stan: "",
    search: "",
    terminalId: "",
    type: "",
    transactionId: "",
    status: "",
    fromDate: "",
    toDate: "",
    limit: "",
  });

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return <TransactionTable filters={filters} onFilterChange={handleFilterChange} />;
};

export default Transactions;
